import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureId } from '../constants/features.constants';
import { StateStoreService } from '../services/state-store/state-store';

/**
 * Trust Centre route gate — a thin proxy over the platform-wide
 * `hasFeature('trust_center')` primitive. The plan features + any
 * SUPER_MANAGER override + the SUPER_MANAGER role bypass all resolve
 * through the same source of truth (the BE `entitlement_map`), so this
 * guard needs no plan-id / persona branching — a manager acting on a
 * customer sees the flag flip through the whoami entitlement block.
 *
 * Readiness is guaranteed by `appReadyMatch` at the route level.
 */
export const trustCenterGuard: CanActivateFn = () => {
  const state = inject(StateStoreService);
  const router = inject(Router);

  return state.hasFeature(FeatureId.TRUST_CENTER) ? true : router.createUrlTree(['/assessment']);
};
